import React, {useState, useEffect} from "react"
import JackImage from "./JackImage"
import SpeakToJack from "./SpeakToJack"
import MemoryGame from "./MemoryGame"
import MemoryGameReward from "./MemoryGameReward"

function FourJokers(props) {
    const [gameStatus, setGameStatus] = useState("")
    
    useEffect(() => {
        if (props.puzzleCompleted.memoryGame) {
            setGameStatus(<MemoryGameReward goToScience={props.goToScience}/>)
        } else if (props.puzzleCompleted.speakToJack) {
            setGameStatus (<MemoryGame startCountdown={props.startCountdown} callBackMemory={props.callBackMemory} timeLimit={props.timeLimit}/>)
        } else {
            setGameStatus(<SpeakToJack playJack={props.playJack} />)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.puzzleCompleted])
    
    useEffect(() => {
        if (props.timeLimit > 60) {
            setGameStatus(<MemoryGame startCountdown={props.startCountdown} callBackMemory={props.callBackMemory} timeLimit={props.timeLimit}/>)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.timeLimit])
            
    return (
            <div className="imageTextWrapper" id="fourJokersWrapper">
                <JackImage />
                {gameStatus}             
            </div>
    )
}

export default FourJokers